/* unplugin-vue-components disabled */import script from "./Demo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Demo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__